import type { ReactElement, SVGProps } from "react";

export function SkillCheckSmallIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      {...props}
    >
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}
